import { render, staticRenderFns } from "./compareOrdersByDateModal.vue?vue&type=template&id=2d085b95&scoped=true&"
import script from "./compareOrdersByDateModal.vue?vue&type=script&lang=js&"
export * from "./compareOrdersByDateModal.vue?vue&type=script&lang=js&"
import style0 from "./compareOrdersByDateModal.vue?vue&type=style&index=0&id=2d085b95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d085b95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardActions,VCardText,VDataTable,VDialog,VFooter,VSelect})
